import React from 'react'
import { useTranslation } from 'react-i18next'

import { CookiePolicyLink } from 'components/CookiePolicyLink'
import { PrivacyPolicyLink } from 'components/PrivacyPolicyLink'
import { TermsOfUseLink } from 'components/TermsOfUseLink'

import {
  StyledTermsLinksGroup as S,
  TTermsLinksGroupVariant,
} from './TermsLinksGroup.styles'

type TProps = {
  titleKey: string
  termsOfUseTranslationKey?: string
  variant: TTermsLinksGroupVariant
}

export const TermsLinksGroup: React.FC<TProps> = ({
  titleKey,
  termsOfUseTranslationKey,
  variant,
}) => {
  const { t } = useTranslation()

  return (
    <S.Container $variant={variant}>
      <p>{t(titleKey)}</p>
      <PrivacyPolicyLink />
      <S.Separator $variant={variant} />
      <CookiePolicyLink />
      <S.Separator $variant={variant} />
      <TermsOfUseLink translationKey={termsOfUseTranslationKey} />
    </S.Container>
  )
}
